// PageHeader: a page's title, a muted line saying what the page is for, and its actions.
import type { ReactNode } from 'react';
import { cn } from './cn';

export function PageHeader({
  title,
  purpose,
  actions,
  className,
}: {
  title: ReactNode;
  purpose?: ReactNode;
  actions?: ReactNode;
  className?: string;
}) {
  return (
    <header className={cn('flex flex-wrap items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        <h1 className="m-0 mb-1 text-[20px] font-semibold tracking-[-0.02em]">{title}</h1>
        {purpose && <p className="m-0 text-ink-muted">{purpose}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
